import { collection, getDocs, query, where } from 'firebase/firestore';

import { db } from '../../config';

export const fetchDocumentsByIds = async <T>(collectionPath: string, ids: string[]): Promise<T[]> => {
  const q = query(collection(db, collectionPath), where('__name__', 'in', ids));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }) as unknown as T);
};
